import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css"; // Tailwind styles

// Use a custom container div just for the Hot Seat Game
const root = document.getElementById("hangman-themed-root");

if (root) {
    ReactDOM.createRoot(root).render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
} else {
    console.error("No root element found in index.html!");
}
